
export const Events = () => {
    return (
        <div className="space-y-[20px]">
            <div className="font-bold text-[14px] leading-[20px]">
                Eventi
            </div>
            <div className="">
                Eventi per il buon vecchio Pres @PietroLombardo
            </div>
        </div>
    )
}

export const Notifications = () => {
    return (
        <div className="space-y-[20px]">
            <div className="font-bold text-[14px] leading-[20px]">
                Notifiche
            </div>
            <div className="">
                Notifiche per la mitica @Sibilla
            </div>
        </div>
    )
}

export const Trackings = () => {
    return (
        <div className="space-y-[20px]">
            <div className="font-bold text-[14px] leading-[20px]">
                Tracking
            </div>
            <div className="">
                Possiamo modificare il tracking dei nostri pazienti?
            </div>
        </div>
    )
}

export const StripePurchases = () => {
    return (
        <div className="space-y-[20px]">
            <div className="font-bold text-[14px] leading-[20px]">
                Acquisti su Stripe
            </div>
            <div className="">
                Vuoi aggiungere un acquisto su Stripe?
            </div>
        </div>
    )
}
